import { AsyncActions } from "../base";
export interface ITeamsActions {}

export class TeamsActions extends AsyncActions implements ITeamsActions {}
